//NO SÉ SI TIENE SENTIDO PERO LO MANTENGO POR LOS ERRORES
export const APP_HOME = "/secure/index";
